import { Controller } from "@hotwired/stimulus"

// Toggles the capacity-planning right stats sidebar. State persists in a cookie so
// the server can render the collapsed state into the markup at first paint (full
// load and Turbo navigation), avoiding a flash of the expanded sidebar (mirrors
// sites-sidebar / tasks-sidebar).
export default class extends Controller {
  static targets = ["expanded", "collapsed"]

  connect() {
    this.applyState(this.readStoredState())
  }

  toggle() {
    const collapsed = !this.expandedTarget.classList.contains("hidden")
    this.applyState(collapsed)
    this.writeStoredState(collapsed)
  }

  applyState(collapsed) {
    if (this.hasExpandedTarget) {
      this.expandedTarget.classList.toggle("hidden", collapsed)
    }
    if (this.hasCollapsedTarget) {
      this.collapsedTarget.classList.toggle("hidden", !collapsed)
    }
  }

  readStoredState() {
    return document.cookie.split("; ").some((entry) => entry === `${this.cookieName}=1`)
  }

  writeStoredState(collapsed) {
    if (collapsed) {
      document.cookie = `${this.cookieName}=1; path=/; max-age=31536000; SameSite=Lax`
    } else {
      document.cookie = `${this.cookieName}=; path=/; max-age=0; SameSite=Lax`
    }
  }

  get cookieName() {
    return "planning_sidebar_collapsed"
  }
}
